export const negativeQuestions = [
  {
    questionNumber: 1,
    questionText:
      "Shouldn't we confirm the budget before starting the project?",
    choices: {
      A: "Yes, let's review it now.",
      B: "The project will begin next month.",
      C: "Our team submitted the report.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "프로젝트를 시작하기 전에 예산을 확인해봐야 하지 않을까요?",
      choices: {
        A: "네, 지금 검토해보죠.",
        B: "프로젝트는 다음 달에 시작될 예정입니다.",
        C: "우리 팀이 보고서를 제출했습니다.",
      },
    },
    explanation:
      "부정 의문문에서도 답변의 기준은 단순합니다. 'Shouldn't we confirm?'(확인해야 하지 않을까요?)라는 질문에서 '확인해야 한다'가 맞으면 'Yes', '확인할 필요 없다'가 맞으면 'No'입니다. A는 예산 확인이 필요하다고 생각하므로 'Yes'로 답하고 즉각적인 검토를 제안했습니다.",
  },
  {
    questionNumber: 2,
    questionText: "Can't we extend the deadline for this project?",
    choices: {
      A: "The report was submitted on time.",
      B: "Our team is working remotely.",
      C: "No, the client needs it completed by Friday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 프로젝트 마감일을 연장할 수 없나요?",
      choices: {
        A: "보고서는 제시간에 제출되었습니다.",
        B: "우리 팀은 원격으로 일하고 있습니다.",
        C: "할 수 없어요, 고객이 금요일까지 완료를 요청했습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Can't we extend?'(연장할 수 없나요?)라는 질문에서 '연장할 수 없다'가 맞으면 'No', '연장할 수 있다'가 맞으면 'Yes'입니다. C는 고객의 요청으로 연장이 불가능하다고 판단하여 'No'로 답하고 그 이유를 설명했습니다.",
  },
  {
    questionNumber: 3,
    questionText: "Didn't the supplier confirm the shipment date?",
    choices: {
      A: "The shipment will be sent overseas.",
      B: "Yes, they said it would be delivered tomorrow.",
      C: "The products are high quality.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "공급업체가 배송 날짜를 확인하지 않았나요?",
      choices: {
        A: "배송품은 해외로 보내질 예정입니다.",
        B: "네, 내일 배송된다고 했습니다.",
        C: "제품들은 고품질입니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Didn't they confirm?'(확인하지 않았나요?)라는 질문에서 '확인했다'가 맞으면 'Yes', '확인하지 않았다'가 맞으면 'No'입니다. B는 공급업체가 배송 날짜를 확인했으므로 'Yes'로 답하고 구체적인 배송 일정을 설명했습니다.",
  },
  {
    questionNumber: 4,
    questionText: "Haven't we already sent the invoice to the client?",
    choices: {
      A: "The client is requesting a discount.",
      B: "Our finance team manages invoices.",
      C: "Yes, it was emailed this morning.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "우리가 이미 고객에게 송장을 보내지 않았나요?",
      choices: {
        A: "고객이 할인을 요청하고 있습니다.",
        B: "우리 재무팀이 송장을 관리합니다.",
        C: "네, 오늘 아침에 이메일로 보냈습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Haven't we sent?'(보내지 않았나요?)라는 질문에서 '이미 보냈다'가 맞으면 'Yes', '아직 보내지 않았다'가 맞으면 'No'입니다. C는 송장이 이미 발송되었으므로 'Yes'로 답하고 구체적인 발송 시점을 설명했습니다.",
  },
  {
    questionNumber: 5,
    questionText: "Shouldn't we notify the team about the schedule change?",
    choices: {
      A: "Yes, I'll send an email right away.",
      B: "The meeting will be held in the main conference room.",
      C: "The new schedule was decided last week.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "팀에게 일정 변경을 알려야 하지 않을까요?",
      choices: {
        A: "네, 바로 이메일을 보내도록 하겠습니다.",
        B: "회의는 주 회의실에서 열릴 예정입니다.",
        C: "새로운 일정은 지난주에 결정되었습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Shouldn't we notify?'(알려야 하지 않을까요?)라는 질문에서 '알려야 한다'가 맞으면 'Yes', '알릴 필요 없다'가 맞으면 'No'입니다. A는 팀에게 알려야 한다고 판단하여 'Yes'로 답하고 즉각적인 행동을 제안했습니다.",
  },
  {
    questionNumber: 6,
    questionText: "Wouldn't it be more efficient to automate this process?",
    choices: {
      A: "Yes, automation would save time.",
      B: "Our IT team is working on another project.",
      C: "The system was updated recently.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 과정을 자동화하는 것이 더 효율적이지 않을까요?",
      choices: {
        A: "네, 자동화하면 시간을 절약할 수 있을 것 같습니다.",
        B: "우리 IT팀이 다른 프로젝트를 진행 중입니다.",
        C: "시스템이 최근에 업데이트되었습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Wouldn't it be efficient?'(효율적이지 않을까요?)라는 질문에서 '효율적이다'가 맞으면 'Yes', '효율적이지 않다'가 맞으면 'No'입니다. A는 자동화가 효율적이라고 판단하여 'Yes'로 답하고 시간 절약이라는 구체적인 이점을 설명했습니다.",
  },
  {
    questionNumber: 7,
    questionText: "Can't we schedule the presentation for next week instead?",
    choices: {
      A: "Our team will attend the meeting.",
      B: "No, the client is only available this Friday.",
      C: "The presentation slides are ready.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "발표를 다음 주로 일정을 변경할 수 없나요?",
      choices: {
        A: "우리 팀이 회의에 참석할 예정입니다.",
        B: "할 수 없습니다, 고객이 이번 주 금요일에만 가능합니다.",
        C: "발표 자료가 준비되어 있습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Can't we schedule?'(일정 변경할 수 없나요?)라는 질문에서 '변경할 수 없다'가 맞으면 'No', '변경할 수 있다'가 맞으면 'Yes'입니다. B는 고객의 일정 때문에 변경이 불가능하다고 판단하여 'No'로 답하고 구체적인 이유를 설명했습니다.",
  },
  {
    questionNumber: 8,
    questionText: "Shouldn't we leave earlier to avoid traffic?",
    choices: {
      A: "I usually drive to work.",
      B: "Yes, let's leave now.",
      C: "The traffic is bad in the morning.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "교통 체증을 피하기 위해 일찍 출발해야 하지 않을까요?",
      choices: {
        A: "저는 보통 운전해서 출근합니다.",
        B: "네, 지금 출발하죠.",
        C: "아침에는 교통이 혼잡합니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Shouldn't we leave earlier?'(일찍 출발해야 하지 않을까요?)라는 질문에서 '일찍 출발해야 한다'가 맞으면 'Yes', '일찍 출발할 필요 없다'가 맞으면 'No'입니다. B는 일찍 출발하는 것이 좋다고 판단하여 'Yes'로 답하고 즉각적인 행동을 제안했습니다.",
  },
  {
    questionNumber: 9,
    questionText: "Wouldn't it be better to book a direct flight?",
    choices: {
      A: "The airport is very busy today.",
      B: "I prefer traveling by train.",
      C: "Yes, it's more convenient.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "직항편을 예약하는 것이 더 좋지 않을까요?",
      choices: {
        A: "오늘은 공항이 매우 붐빕니다.",
        B: "저는 기차 여행을 선호합니다.",
        C: "네, 그게 더 편리할 것 같습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Wouldn't it be better?'(더 좋지 않을까요?)라는 질문에서 '더 좋다'가 맞으면 'Yes', '더 좋지 않다'가 맞으면 'No'입니다. C는 직항편이 더 편리하다고 판단하여 'Yes'로 답하고 그 이유를 설명했습니다.",
  },
  {
    questionNumber: 10,
    questionText: "Can't we reschedule the dinner for another day?",
    choices: {
      A: "No, everyone is only available today.",
      B: "The restaurant is fully booked.",
      C: "I already ordered my meal.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "저녁 식사 일정을 다른 날로 변경할 수 없나요?",
      choices: {
        A: "할 수 없습니다, 모두 오늘만 시간이 됩니다.",
        B: "레스토랑이 만석입니다.",
        C: "저는 이미 음식을 주문했습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Can't we reschedule?'(일정 변경할 수 없나요?)라는 질문에서 '변경할 수 없다'가 맞으면 'No', '변경할 수 있다'가 맞으면 'Yes'입니다. A는 모든 사람의 일정 때문에 변경이 불가능하다고 판단하여 'No'로 답하고 그 이유를 설명했습니다.",
  },
  {
    questionNumber: 11,
    questionText: "Didn't you already watch this movie?",
    choices: {
      A: "The movie was released last year.",
      B: "I usually go to the theater on weekends.",
      C: "Yes, but I don't mind watching it again.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 영화를 이미 보지 않았나요?",
      choices: {
        A: "이 영화는 작년에 개봉했습니다.",
        B: "저는 보통 주말에 영화관에 갑니다.",
        C: "네, 하지만 다시 봐도 괜찮습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Didn't you watch?'(보지 않았나요?)라는 질문에서 '이미 봤다'가 맞으면 'Yes', '아직 보지 않았다'가 맞으면 'No'입니다. C는 이미 영화를 봤다고 인정하여 'Yes'로 답하고 재관람 의사도 함께 표현했습니다.",
  },
  {
    questionNumber: 12,
    questionText: "Haven't they delivered the package yet?",
    choices: {
      A: "I ordered something online last week.",
      B: "The delivery company is very reliable.",
      C: "No, it's still on the way.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "아직 택배가 배달되지 않았나요?",
      choices: {
        A: "지난주에 온라인으로 주문했습니다.",
        B: "배송 회사는 매우 신뢰할 만합니다.",
        C: "아니요, 아직 배송 중입니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Haven't they delivered?'(배달되지 않았나요?)라는 질문에서 '배달되지 않았다'가 맞으면 'No', '이미 배달됐다'가 맞으면 'Yes'입니다. C는 아직 배송이 완료되지 않았다고 판단하여 'No'로 답하고 현재 배송 상태를 설명했습니다.",
  },
  {
    questionNumber: 13,
    questionText: "Doesn't this coffee taste a little too bitter?",
    choices: {
      A: "Yes, it's stronger than usual.",
      B: "I usually drink tea.",
      C: "The café has a great atmosphere.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 커피가 좀 너무 쓴맛이 나지 않나요?",
      choices: {
        A: "네, 평소보다 진하네요.",
        B: "저는 보통 차를 마십니다.",
        C: "이 카페는 분위기가 좋습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Doesn't it taste bitter?'(쓴맛이 나지 않나요?)라는 질문에서 '쓴맛이 난다'가 맞으면 'Yes', '쓴맛이 나지 않는다'가 맞으면 'No'입니다. A는 커피가 평소보다 진하다고 판단하여 'Yes'로 답하고 구체적인 설명을 덧붙였습니다.",
  },
  {
    questionNumber: 14,
    questionText: "Shouldn't we call a taxi instead of walking?",
    choices: {
      A: "I like walking in the evening.",
      B: "Yes, it would be faster.",
      C: "The streets are crowded today.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "걸어가는 대신 택시를 부르는 게 좋지 않을까요?",
      choices: {
        A: "저는 저녁 산책을 좋아합니다.",
        B: "네, 그게 더 빠를 것 같네요.",
        C: "오늘은 거리가 붐빕니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Shouldn't we call a taxi?'(택시를 불러야 하지 않을까요?)라는 질문에서 '택시를 불러야 한다'가 맞으면 'Yes', '택시를 부를 필요 없다'가 맞으면 'No'입니다. B는 택시가 더 빠른 방법이라고 판단하여 'Yes'로 답하고 그 이유를 설명했습니다.",
  },
  {
    questionNumber: 15,
    questionText: "Wouldn't it be nice to take a day off next week?",
    choices: {
      A: "Yes, we could use a break.",
      B: "I have a lot of work to do.",
      C: "I usually take vacations in the summer.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "다음 주에 하루 쉬면 좋지 않을까요?",
      choices: {
        A: "네, 휴식이 필요할 것 같네요.",
        B: "해야 할 일이 많습니다.",
        C: "저는 보통 여름에 휴가를 갑니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Wouldn't it be nice?'(좋지 않을까요?)라는 질문에서 '좋을 것 같다'가 맞으면 'Yes', '좋지 않을 것 같다'가 맞으면 'No'입니다. A는 휴식이 필요하다고 판단하여 'Yes'로 답하고 그 이유를 설명했습니다.",
  },
  {
    questionNumber: 16,
    questionText: "Can't you hear the music from the next room?",
    choices: {
      A: "The speaker system is very good.",
      B: "No, it's too quiet here.",
      C: "I enjoy listening to music.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "옆방에서 나는 음악 소리가 들리지 않나요?",
      choices: {
        A: "스피커 시스템이 매우 좋습니다.",
        B: "아니요, 여기는 너무 조용해서 안 들립니다.",
        C: "저는 음악 듣는 것을 즐깁니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Can't you hear?'(들리지 않나요?)라는 질문에서 '들리지 않는다'가 맞으면 'No', '들린다'가 맞으면 'Yes'입니다. B는 음악 소리가 들리지 않는다고 판단하여 'No'로 답하고 그 이유를 설명했습니다.",
  },
  {
    questionNumber: 17,
    questionText: "Didn't we already send the revised proposal?",
    choices: {
      A: "The client liked our proposal.",
      B: "The sales team is handling negotiations.",
      C: "No, we still need to finalize it.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "수정된 제안서를 이미 보내지 않았나요?",
      choices: {
        A: "고객이 우리 제안서를 마음에 들어 했습니다.",
        B: "영업팀이 협상을 진행하고 있습니다.",
        C: "아니요, 아직 최종 검토가 필요합니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Didn't we send?'(보내지 않았나요?)라는 질문에서 '아직 보내지 않았다'가 맞으면 'No', '이미 보냈다'가 맞으면 'Yes'입니다. C는 아직 보내지 않았다고 판단하여 'No'로 답하고 그 이유를 설명했습니다.",
  },
  {
    questionNumber: 18,
    questionText: "Isn't the new policy more flexible than before?",
    choices: {
      A: "Yes, employees now have more options.",
      B: "The policy applies to all departments.",
      C: "HR is responsible for implementing policies.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새로운 정책이 이전보다 더 유연하지 않나요?",
      choices: {
        A: "네, 직원들에게 더 많은 선택권이 주어졌습니다.",
        B: "이 정책은 모든 부서에 적용됩니다.",
        C: "인사팀이 정책 시행을 담당합니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it more flexible?'(더 유연하지 않나요?)라는 질문에서 '더 유연하다'가 맞으면 'Yes', '더 유연하지 않다'가 맞으면 'No'입니다. A는 새 정책이 더 유연하다고 판단하여 'Yes'로 답하고 구체적인 예시를 설명했습니다.",
  },
  {
    questionNumber: 19,
    questionText: "Isn't this software compatible with our system?",
    choices: {
      A: "The software has multiple features.",
      B: "No, we need to update our current system.",
      C: "The IT team installed the software yesterday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 소프트웨어가 우리 시스템과 호환되지 않나요?",
      choices: {
        A: "이 소프트웨어는 다양한 기능이 있습니다.",
        B: "아니요, 현재 시스템을 업데이트해야 합니다.",
        C: "IT팀이 어제 소프트웨어를 설치했습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it compatible?'(호환되지 않나요?)라는 질문에서 '호환되지 않는다'가 맞으면 'No', '호환된다'가 맞으면 'Yes'입니다. B는 현재 시스템과 호환되지 않는다고 판단하여 'No'로 답하고 필요한 조치를 설명했습니다.",
  },
  {
    questionNumber: 20,
    questionText: "Isn't the budget for this project too low?",
    choices: {
      A: "The finance team prepared the budget.",
      B: "The project is scheduled to start next month.",
      C: "Yes, we may need additional funding.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 프로젝트의 예산이 너무 적지 않나요?",
      choices: {
        A: "재무팀이 예산을 준비했습니다.",
        B: "프로젝트는 다음 달에 시작될 예정입니다.",
        C: "네, 추가 자금이 필요할 것 같습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it too low?'(너무 적지 않나요?)라는 질문에서 '너무 적다'가 맞으면 'Yes', '적지 않다'가 맞으면 'No'입니다. C는 예산이 부족하다고 판단하여 'Yes'로 답하고 추가 자금 필요성을 설명했습니다.",
  },
  {
    questionNumber: 21,
    questionText: "Isn't this deadline too tight for the team?",
    choices: {
      A: "Yes, we may need an extension.",
      B: "The project requires collaboration from all teams.",
      C: "The next project will start next quarter.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 마감 기한이 팀에게 너무 촉박하지 않나요?",
      choices: {
        A: "네, 기한 연장이 필요할 것 같습니다.",
        B: "이 프로젝트는 모든 팀의 협력이 필요합니다.",
        C: "다음 프로젝트는 다음 분기에 시작됩니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it too tight?'(너무 촉박하지 않나요?)라는 질문에서 '촉박하다'가 맞으면 'Yes', '촉박하지 않다'가 맞으면 'No'입니다. A는 마감 기한이 촉박하다고 판단하여 'Yes'로 답하고 기한 연장 필요성을 설명했습니다.",
  },
  {
    questionNumber: 22,
    questionText: "Isn't our office space too small for the growing team?",
    choices: {
      A: "Our company has multiple offices.",
      B: "The HR team is hiring new employees.",
      C: "Yes, we are considering relocating.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "늘어나는 팀원들에 비해 사무실 공간이 너무 좁지 않나요?",
      choices: {
        A: "우리 회사는 여러 사무실을 가지고 있습니다.",
        B: "인사팀이 새 직원을 채용하고 있습니다.",
        C: "네, 이전을 고려하고 있습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it too small?'(너무 좁지 않나요?)라는 질문에서 '좁다'가 맞으면 'Yes', '좁지 않다'가 맞으면 'No'입니다. C는 사무실이 좁다고 판단하여 'Yes'로 답하고 이전 계획을 설명했습니다.",
  },
  {
    questionNumber: 23,
    questionText: "Isn't this restaurant famous for its seafood?",
    choices: {
      A: "Yes, their grilled salmon is very popular.",
      B: "The restaurant is located downtown.",
      C: "I don't eat seafood often.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 식당이 해산물로 유명하지 않나요?",
      choices: {
        A: "네, 이곳의 연어구이가 매우 인기가 있습니다.",
        B: "이 식당은 시내에 위치해 있습니다.",
        C: "저는 해산물을 자주 먹지 않습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it famous?'(유명하지 않나요?)라는 질문에서 '유명하다'가 맞으면 'Yes', '유명하지 않다'가 맞으면 'No'입니다. A는 식당이 해산물로 유명하다고 판단하여 'Yes'로 답하고 대표 메뉴를 예시로 들었습니다.",
  },
  {
    questionNumber: 24,
    questionText: "Isn't the weather too cold for a picnic?",
    choices: {
      A: "I usually go on picnics in the summer.",
      B: "Yes, we should bring extra jackets.",
      C: "The park has a great picnic area.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "날씨가 소풍 가기에는 너무 춥지 않나요?",
      choices: {
        A: "저는 보통 여름에 소풍을 갑니다.",
        B: "네, 자켓을 더 가져가야 할 것 같습니다.",
        C: "공원에는 좋은 피크닉 장소가 있습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it too cold?'(너무 춥지 않나요?)라는 질문에서 '춥다'가 맞으면 'Yes', '춥지 않다'가 맞으면 'No'입니다. B는 날씨가 춥다고 판단하여 'Yes'로 답하고 대비책을 제안했습니다.",
  },
  {
    questionNumber: 25,
    questionText: "Isn't she your best friend?",
    choices: {
      A: "Yes, we've known each other since high school.",
      B: "I met her at a party.",
      C: "She works at a bank.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그녀가 당신의 가장 친한 친구 아닌가요?",
      choices: {
        A: "네, 고등학교 때부터 알고 지냈어요.",
        B: "파티에서 그녀를 만났어요.",
        C: "그녀는 은행에서 일해요.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't she your best friend?'(가장 친한 친구 아닌가요?)라는 질문에서 '가장 친한 친구가 맞다'가 맞으면 'Yes', '가장 친한 친구가 아니다'가 맞으면 'No'입니다. A는 오랜 친구 사이임을 확인하여 'Yes'로 답하고 구체적인 관계를 설명했습니다.",
  },
  {
    questionNumber: 26,
    questionText: "Isn't your flight early in the morning?",
    choices: {
      A: "The airport is very busy on weekends.",
      B: "Yes, I need to leave for the airport at 5 AM.",
      C: "I love traveling.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "당신의 비행기가 이른 아침 아닌가요?",
      choices: {
        A: "공항은 주말에 매우 붐빕니다.",
        B: "네, 공항에 새벽 5시에 가야 합니다.",
        C: "저는 여행하는 것을 좋아합니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it early?'(이른 아침 아닌가요?)라는 질문에서 '이른 아침이 맞다'가 맞으면 'Yes', '이른 아침이 아니다'가 맞으면 'No'입니다. B는 이른 아침 비행기임을 확인하여 'Yes'로 답하고 구체적인 출발 시간을 설명했습니다.",
  },
  {
    questionNumber: 27,
    questionText: "Isn't your house near the train station?",
    choices: {
      A: "The train station is very modern.",
      B: "Yes, it's just a five-minute walk.",
      C: "I moved to a new apartment recently.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "당신의 집이 기차역 근처 아닌가요?",
      choices: {
        A: "기차역이 매우 현대적입니다.",
        B: "네, 도보로 5분 거리입니다.",
        C: "최근에 새 아파트로 이사했습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Isn't it near?'(근처 아닌가요?)라는 질문에서 '근처가 맞다'가 맞으면 'Yes', '근처가 아니다'가 맞으면 'No'입니다. B는 집이 기차역 근처임을 확인하여 'Yes'로 답하고 구체적인 거리를 설명했습니다.",
  },
  {
    questionNumber: 28,
    questionText: "Isn't the deadline next Friday?",
    choices: {
      A: "I think so.",
      B: "No, the project is very important.",
      C: "The deadline was already confirmed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "마감일이 다음 주 금요일 아닌가요?",
      choices: {
        A: "그런 것 같아요.",
        B: "아니요, 이 프로젝트는 매우 중요합니다.",
        C: "마감일은 이미 확정되었습니다.",
      },
    },
    explanation:
      "부정 의문문에서 확실하지 않은 정보에 대해 답변할 때는 'I think so'와 같은 애매한 표현을 사용할 수 있습니다. A는 마감일이 다음 주 금요일일 것 같다는 추측을 나타내는 적절한 답변입니다.",
  },
  {
    questionNumber: 29,
    questionText: "Didn't the manager approve the budget?",
    choices: {
      A: "The budget was discussed in the last meeting.",
      B: "I don't think so.",
      C: "No, the company has a budget plan.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "매니저가 예산을 승인하지 않았나요?",
      choices: {
        A: "예산은 지난 회의에서 논의되었습니다.",
        B: "그렇지 않은 것 같아요.",
        C: "아니요, 회사에 예산 계획이 있습니다.",
      },
    },
    explanation:
      "부정 의문문에서 확실하지 않은 정보에 대해 답변할 때는 'I don't think so'와 같은 애매한 표현을 사용할 수 있습니다. B는 예산 승인 여부에 대해 확신하지 못하는 상황을 적절하게 표현했습니다.",
  },
  {
    questionNumber: 30,
    questionText: "Isn't the client expecting a response today?",
    choices: {
      A: "I think so, but I'm not sure.",
      B: "Yes, we usually respond quickly.",
      C: "The client is based overseas.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "고객이 오늘 답변을 기대하고 있지 않나요?",
      choices: {
        A: "그런 것 같은데, 확실하지는 않아요.",
        B: "네, 우리는 보통 빨리 답변합니다.",
        C: "고객사는 해외에 있습니다.",
      },
    },
    explanation:
      "부정 의문문에서 확실하지 않은 정보에 대해 답변할 때는 'I think so, but I'm not sure'와 같은 애매한 표현을 사용할 수 있습니다. A는 고객의 기대 여부에 대해 확신하지 못하는 상황을 적절하게 표현했습니다.",
  },
  {
    questionNumber: 31,
    questionText: "Haven't they finished the project yet?",
    choices: {
      A: "Yes, but I need to check my emails first.",
      B: "No, they're still working on the final report.",
      C: "I attended the project briefing last week.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그들이 아직 프로젝트를 끝내지 않았나요?",
      choices: {
        A: "네, 하지만 먼저 이메일을 확인해야 합니다.",
        B: "아니요, 아직 최종 보고서 작업 중입니다.",
        C: "지난주에 프로젝트 브리핑에 참석했습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Haven't they finished?'(끝내지 않았나요?)라는 질문에서 '아직 끝내지 않았다'가 맞으면 'No', '이미 끝냈다'가 맞으면 'Yes'입니다. B는 프로젝트가 아직 완료되지 않았다고 판단하여 'No'로 답하고 현재 진행 상황도 함께 설명했습니다.",
  },
  {
    questionNumber: 32,
    questionText: "Isn't the meeting scheduled for 10 AM?",
    choices: {
      A: "No, meetings are always important.",
      B: "The meeting was confirmed last week.",
      C: "I think so, but I'll check the calendar.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "회의가 오전 10시로 예정되어 있지 않나요?",
      choices: {
        A: "아니요, 회의는 항상 중요합니다.",
        B: "회의는 지난주에 확정되었습니다.",
        C: "그런 것 같은데, 캘린더를 확인해보겠습니다.",
      },
    },
    explanation:
      "부정 의문문에서 확실하지 않은 정보에 대해 답변할 때는 'I think so, but I'll check'와 같은 애매한 표현을 사용할 수 있습니다. C는 회의 시간에 대해 확신하지 못하여 확인이 필요한 상황을 적절하게 표현했습니다.",
  },
  {
    questionNumber: 33,
    questionText: "Wasn't the meeting supposed to start at 9 AM?",
    choices: {
      A: "I think so, but it might have been delayed.",
      B: "The meeting room is on the second floor.",
      C: "We hold meetings every Monday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의가 오전 9시에 시작하기로 되어 있지 않았나요?",
      choices: {
        A: "그런 것 같은데, 지연되었을 수도 있어요.",
        B: "회의실은 2층에 있습니다.",
        C: "우리는 매주 월요일에 회의를 합니다.",
      },
    },
    explanation:
      "부정 의문문에서 확실하지 않은 정보에 대해 답변할 때는 'I think so, but...'와 같은 애매한 표현을 사용할 수 있습니다. A는 회의 시작 시간에 대해 확신하지 못하고 지연 가능성을 언급하며 상황을 적절하게 표현했습니다.",
  },
  {
    questionNumber: 34,
    questionText: "Wasn't the new policy announced last week?",
    choices: {
      A: "HR is responsible for policy updates.",
      B: "Yes, but not everyone has read it yet.",
      C: "The policy affects all employees.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "새로운 정책이 지난주에 발표되지 않았나요?",
      choices: {
        A: "인사팀이 정책 업데이트를 담당합니다.",
        B: "네, 하지만 아직 모든 직원이 읽지는 않았습니다.",
        C: "이 정책은 모든 직원에게 영향을 미칩니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Wasn't it announced?'(발표되지 않았나요?)라는 질문에서 '발표되었다'가 맞으면 'Yes', '발표되지 않았다'가 맞으면 'No'입니다. B는 정책이 발표되었음을 확인하여 'Yes'로 답하고 현재 상황도 함께 설명했습니다.",
  },
  {
    questionNumber: 35,
    questionText: "Didn't you receive the event invitation?",
    choices: {
      A: "No, I should check my inbox again.",
      B: "The event is scheduled for next Friday.",
      C: "I attended the same event last year.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "행사 초대장을 받지 않으셨나요?",
      choices: {
        A: "아니요, 받은편지함을 다시 확인해봐야겠습니다.",
        B: "행사는 다음 주 금요일로 예정되어 있습니다.",
        C: "저는 작년에 같은 행사에 참석했습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Didn't you receive?'(받지 않았나요?)라는 질문에서 '받지 않았다'가 맞으면 'No', '받았다'가 맞으면 'Yes'입니다. A는 초대장을 받지 않았다고 판단하여 'No'로 답하고 확인이 필요하다는 후속 조치도 함께 설명했습니다.",
  },
  {
    questionNumber: 36,
    questionText: "Didn't they hire a new marketing director?",
    choices: {
      A: "No, they're still in the process of interviewing candidates.",
      B: "The company launched a new advertising campaign.",
      C: "I applied for a different position.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새로운 마케팅 디렉터를 채용하지 않았나요?",
      choices: {
        A: "아니요, 아직 후보자들을 면접하는 중입니다.",
        B: "회사가 새로운 광고 캠페인을 시작했습니다.",
        C: "저는 다른 포지션에 지원했습니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Didn't they hire?'(채용하지 않았나요?)라는 질문에서 '채용하지 않았다'가 맞으면 'No', '채용했다'가 맞으면 'Yes'입니다. A는 아직 채용이 완료되지 않았다고 판단하여 'No'로 답하고 현재 채용 진행 상황도 함께 설명했습니다.",
  },
  {
    questionNumber: 37,
    questionText: "Aren't you responsible for training new employees?",
    choices: {
      A: "No, I only assist with onboarding.",
      B: "The HR team conducts training sessions.",
      C: "The company hires new employees regularly.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "당신이 신입 직원 교육을 담당하고 있지 않나요?",
      choices: {
        A: "아니요, 저는 온보딩을 보조하는 일만 합니다.",
        B: "인사팀이 교육 세션을 진행합니다.",
        C: "회사는 정기적으로 신입 직원을 채용합니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Aren't you responsible?'(담당하고 있지 않나요?)라는 질문에서 '담당하고 있지 않다'가 맞으면 'No', '담당하고 있다'가 맞으면 'Yes'입니다. A는 교육 담당이 아님을 명확히 하여 'No'로 답하고 실제 자신의 역할을 설명했습니다.",
  },
  {
    questionNumber: 38,
    questionText: "Doesn't he handle customer complaints?",
    choices: {
      A: "He received training last year.",
      B: "Yes, he is in charge of that.",
      C: "The customer service team is very busy.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그가 고객 불만을 처리하지 않나요?",
      choices: {
        A: "그는 작년에 교육을 받았습니다.",
        B: "네, 그가 그 업무를 담당하고 있습니다.",
        C: "고객 서비스팀이 매우 바쁩니다.",
      },
    },
    explanation:
      "부정 의문문에서 답변의 기준은 단순합니다. 'Doesn't he handle?'(처리하지 않나요?)라는 질문에서 '처리한다'가 맞으면 'Yes', '처리하지 않는다'가 맞으면 'No'입니다. B는 그가 고객 불만 처리를 담당하고 있음을 확인하여 'Yes'로 답했습니다.",
  },
];
